<template>
  <v-row justify="center">
    <v-dialog
      v-model="modal"
      persistent
      :width="$vuetify.breakpoint.smAndDown ? null : '45%'"
    >
      <v-card class="mx-auto pt-4">
        <v-img
          :height="$vuetify.breakpoint.smAndDown ? '100px' : '200px'"
          contain
          src="https://clinicaapps.blob.core.windows.net/static/images/assets/images/mail_sent.svg"
        ></v-img>
        <p class="headline font-weight-medium mt-3 text-center primary--text">
          <slot name="title"></slot>
        </p>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text block @click="closeModal()"
            ><slot name="homeButton"></slot
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {
    modal: {
      default: false,
      type: Boolean
    },
    resources: {
      default: null,
      type: Boolean
    }
  },
  data() {
    return {};
  },
  methods: {
    closeModal() {
      //the method to close the modal
      this.$emit("update:modal");
      this.$router.push({
        name: "forms",
        params: { id: this.$route.params.id }
      });
    }
  }
};
</script>